export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9741.de0cce09.jpg";